import React, { useState, useEffect } from "react";

import { Redirect, Route, Switch } from "react-router-dom";

import NewReg from "../pages/NewReg";
import BankDetails from "./BankDetails";
import Fatca from "./Fatca";
import InvestmentType from "./InvestmentType";
import KycDetails from "./KycDetails";
import NomineeDetails from "./NomineeDetails";
import SchemeDetails from "./NpsSchemeDetails";
import PersonalDetails from "./PersonalDetails";
import SubscriberSummary from "./summary/index";
import UploadDocuments from "./UploadDocuments";
import { setBasicDetails } from "../Context/NewSubscriberAction";
import { useNewSubscriberContext } from "../Context/NewSubsciberContext";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { getEaadhaar, hideLoader, showLoader } from "../../../../store/actions";

function NpsRoutes(props) {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    location: { pathname },
  } = history;
  const { match, location } = props;
  const { path } = match;
  const { search = "" } = location;
  const { dispatch: contextDispatch, pan } = useNewSubscriberContext();
  const [fetchingAADHAARDetails, setFetchingAADHAARDetails] = useState(false);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  useEffect(() => {
    const localContext = JSON.parse(localStorage.getItem("newSub"));

    if (!pan && !localContext && !pathname.includes("new-reg")) {
      history.replace("/nps/AddSubs/new-reg");
      return;
    }

    if (!localContext) {
      return;
    }
    const { dispatch: contextDispatcher, ...others } = localContext;
    contextDispatch(
      setBasicDetails({
        ...others,
      })
    );
    localStorage.removeItem("newSub");

    const urlSearchParams = new URLSearchParams(search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const { code, error, error_description } = params;
    if (!!error && !!error_description) {
      history.push({
        pathname: `${path}/kyc-details`,
      });
      alert(error_description);
      return;
    }
    const getAadhaarDetails = async (_code) => {
      try {
        dispatch(showLoader());
        setFetchingAADHAARDetails(true);
        const response = await dispatch(getEaadhaar({ code: _code }));

        const { data } = response || {};

        const { digilockerData } = data || {};

        if (digilockerData?.Certificate) {
          contextDispatch(
            setBasicDetails({
              aadhaarDetails: digilockerData,
            })
          );
          history.push({
            pathname: `${path}/kyc-details`,
          });
        } else {
          throw new Error("Failed to fetch AADHAAR details. Please try again.");
        }
      } catch (error) {
        alert(error);
        console.error(error);
      } finally {
        dispatch(hideLoader());
        setFetchingAADHAARDetails(false);
      }
    };
    if (!!code) {
      getAadhaarDetails(code);
    }
  }, []);

  if (fetchingAADHAARDetails) {
    return <div>Fetching AADHAAR Details...</div>;
  }
  return (
    <Switch>
      <Route path={`${path}`} exact>
        <Redirect to={`${path}/new-reg${search}`} />
      </Route>
      <Route path={`${path}/new-reg`} component={NewReg} />
      <Route path={`${path}/kyc-details`} component={KycDetails} />
      <Route path={`${path}/personal-details`} component={PersonalDetails} />
      <Route path={`${path}/fatca-details`} component={Fatca} />
      <Route path={`${path}/investment-details`} component={InvestmentType} />
      <Route path={`${path}/scheme-details`} component={SchemeDetails} />
      <Route path={`${path}/nominee-details`} component={NomineeDetails} />
      <Route path={`${path}/bank-details`} component={BankDetails} />
      <Route path={`${path}/upload-documents`} component={UploadDocuments} />
      <Route
        path={`${path}/subscriber-summary`}
        component={SubscriberSummary}
      />
    </Switch>
  );
}

export default NpsRoutes;
